import { render, staticRenderFns } from "./FullSummary.vue?vue&type=template&id=08fadebc&scoped=true&"
import script from "./FullSummary.vue?vue&type=script&lang=js&"
export * from "./FullSummary.vue?vue&type=script&lang=js&"
import style0 from "./FullSummary.vue?vue&type=style&index=0&id=08fadebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fadebc",
  null
  
)

export default component.exports